import isIterable from './isIterable';

/**
 * Checks if the provided object is iterable and if all elements satisfy the provided typeguard-predicate.
 *
 * @param values The iterable values
 * @param predicate The predicate to check
 */
export default function elementsSatisfy<X = any>(
    values: unknown,
    predicate: (x: any) => x is X
): values is Iterable<X>;
/**
 * Checks if the provided object is iterable and if all elements satisfies the provided predicate.
 *
 * @param values The iterable values.
 * @param predicate The predicate to check the values.
 */
export default function elementsSatisfy(
    values: unknown,
    predicate: (x: any) => boolean
): boolean;

export default function elementsSatisfy<X = any>(
    values: unknown,
    predicate: (x: any) => boolean
): values is Iterable<X> {
    if (!isIterable(values)) return false;
    for (const value of values) {
        if (!predicate(value)) return false;
    }
    return true;
}
